export default {
	system: {
		title: 'Smart Street Light Cloud Platform System',
		gas_data: [
			"North Wind",
			"Northeastern Wind",
			"East Wind",
			"Southeast Wind",
			"South Wind",
			"Southwest wind",
			"West Wind",
			"Northwest wind"
		],
		no_data: 'No data!',
		login_out_tip: 'Are you sure you want to log out and exit the system?',
		exit: 'Exit',
		more: 'More',
		username: 'Account',
		password: 'Password',
		login: 'Login',
		password_tip1: 'Password length is 8-20 words (at least two items for uppercase letters, lowercase letters, numbers, and special characters!)',
		password_tip2: 'The password length must be between 6 and 20 words',
		password_tip3: 'Please input a password',
		password_tip4: 'The password cannot be the same as the username or the reverse order of the username',
		please_username: 'Enter one user name',
		username_tip: 'The username is between 4 and 12 characters in length',
		login_tip: 'Password free login requires the user parameter!',
		error: 'Error',
	},
	control: {
		lamp_control: 'Lamp Control',
		camera:'Camera',
		number: 'Number',
		name: 'Name',
		model: 'Model',
		address: 'Address',
		frequency: 'Frequency',
		ip: 'IP',
		strategy: 'Strategy',
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		remove: 'Remove',
		set: 'Set',
		reset: 'Reset',
		all: 'All',
		open: 'Open',
		open_kq: 'Open',
		close: 'Close',
		play: 'Play',
		order: 'Order',
		desc: 'Description',
		submit: 'Submit',
		all_open: 'All Open',
		all_close: 'All Close',
		all_auto: 'All Auto',
		all_manual: 'All Manual',
		import: 'Import',
		batch_import: 'Batch Import',
		down_temp: 'Download template file',
		online: 'Online',
		offline: 'Offline',
		date: 'Date',
		start_date: 'Start Date',
		over_date: 'Over Date',
		time: 'Time',
		start_time: 'Start Time',
		over_time: 'Over Time',
		any_date: 'Any point in time',
		select_date: 'Select date',
		select_time: 'Select time',
		tart_end_time: 'start and end time',
		month: 'Month',
		start_month: 'Start Month',
		over_month: 'Over Month',
		now_month: 'This month',
		year_now: 'To this day',
		near_month6: 'Last six months',
		search: 'Search',
		add_success:'Add successfully!',
		mod_success:'Modified successfully!',
		del_success:'Delete successful!',
		operation_success: 'Operationsuccessful',
		import_success:'Import successful!',
		upload_success:'Upload successful!',
		command_success: 'Command issued successfully',
		refresh_success: 'Refresh successfully',
		error: 'Error, ',
		import_limitation:'The import file can only be in xlsx format!',
		cancel_del: "Cancelled deletion",
		confirm: 'Confirm',
		cancel: 'Cancel',
		tip: 'Tip',
		got_it: 'Got it',
		tip_del_device_title: 'This operation will permanently delete the device. Do you want to continue?',
		tip_del_data_title: 'This operation will permanently delete the data. Do you want to continue?',
		select_file: 'Select File',
		file_upload: 'File Upload',
		to: 'to',
		operate: 'Manage',
		longitude: 'Longitude',
		latitude: 'Latitude',
		lng_lat: 'Lat/Long',
		year: 'Year',
		month: 'Month',
		day: 'Day',
		hour: 'Hour',
		minute: 'Minute',
		second: 'Second',
		select_month: 'Select month',
		set_success: 'Set successfully',
		select_device: 'Select device',
		yes: 'Yes',
		no: 'No'
	},
	home: {
		box1:{
			title: 'Lamp pole statistics',
			text1: 'Total Lamp',
			text2: 'Total Power',
			text3: 'Saved Electricity',
			text4: 'Cloud Box',
			text5: 'Broadcast',
			text6: 'Camera',
			text7: 'Air detection',
			text8: '5G Station',
			text9: 'Alarm',
			text10: 'Charging',
			text11: 'Online',
			text12: 'Offline',
			text13: 'Light up',
		},
		box2:{
			title: 'IP broadcasting',
			text1: 'Total',
			text2: 'Online',
			text3: 'Offline',
			unit: ''
		},
		box3:{
			title: 'Camera',
			deviceArr: ['Broadcast', 'Camera', 'Alarm', 'EM']
		},
		box4:{
			title: 'Air detection',
			text1: 'Temp.',
			text2: 'Hum.',
			text3: 'Illum.',
			text4: 'WS',
			text5: 'WD',
			text6: 'Noise',
			text7: 'Pressure'
		},
		box5:{
			title: 'Screen',
			text1: 'Screen Total',
			text2: 'Total Program List',
			text3: 'None'
		},
		box6:{
			title: 'Alarm Logs',
			text1: 'Lamp Number',
			text2: 'Alarm Date',
			text3: 'Content',
			text4: 'None',
			text5: 'Device',
			text6: 'on'
		},
		box7:{
			title: 'Camera'
		}
	},
	gis:{
		please_name: 'Please Enter Device Name',
		view_camera: 'View Device Camera',
		location_failed: 'Failed to obtain location. Please move the map to locate the location',
		please_search_address: 'Search address',
		nationwide: 'Nationwide',
		not_support: 'Not support',
		please_hand: 'Auto is not support, please manually dragging the map',
	},
	device: {
		lamp: 'Lamp',
		lamp1: 'Lamp 1',
		lamp2: 'Lamp 2',
		number: 'Lamp Number',
		freq_level_arr: ['Offline ',' Extremely Weak ',' Weak ',' Medium ',' Strong',' Extremely Strong ',' Unknown'],
		id:'ID',
		please_id:'Please enter the ID',
		please_name: 'Please enter the name',
		please_device_name: 'Please enter the device name',
		please_device_number: 'Please enter the device number',
		device_number: 'Device Number',
		device_name: 'Device Name',
		device_model: 'Device Model',
		company: 'Company',
		project: 'Project',
		group: 'Group',
		state: 'State',
		strategy: 'Strategy',
		belong_lamp: 'Belonging lamp',
		time_frame: 'Time Frame',
		select_company: 'Please select company',
		select_project: 'Please select project',
		select_group: 'Please select group',
		select_state: 'Please select state',
		select_strategy: 'Please select strategy',
		batch_set_mode: 'Batch setting of street lamp mode',
		single: 'Single lamp',
		double: 'Double lamp',
		single_Double: 'Single/Double',
		select_single_Double: 'Please select Single/Double',
		device_version: 'Device version',
		versionArr:['Old','New'],
		switch_state: 'Switch status',
		light: 'Light',
		light_control: 'Light/Control',
		current_strategy: 'Current strategy',
		online_status: 'Online Status',
		current: 'Current(A)',
		voltage: 'Voltage(V)',
		power: 'Power(W)',
		show_data: 'Show data',
		select_protocol: 'Select protocol',
		gateway_number: 'Gateway number',
		is_home: 'Is home?',
		is_sensor: 'Is sensor installed',
		light_control: 'Brightness control',
		detail:	'Detail',
		lampTypeList: ['', 'Regular Street Light', 'City Circuit Light', 'Solar Energy', 'PLC Street Light'],
		doubleType: ["Single", "Double"],
		steList: ["Offline", "Online"],
		lightStatus: ["Close", "Open"],
		msList: ["(Auto)", "(Manual)"],
		refresh: 'Refresh',
		attribute: 'Attribute',
		detail_text1: 'Lamp Number',
		detail_text2: 'Temperature',
		detail_text3: 'Solar panel voltage',
		detail_text4: 'Battery voltage',
		detail_text5: 'Charging current',
		detail_text6: 'Discharge Voltage',
		detail_text7: 'Discharge Current',
		detail_text8: 'Total charging ampere hours',
		detail_text9: 'Total discharge ampere hours',
		detail_text10: 'Voltage',
		detail_text11: 'Current',
		detail_text12: 'Electricity',
		detail_text13: 'Total electricity',
		detail_text14: 'Drain voltage',
		detail_text15: 'Leakage current',
		detail_text16: 'Power',
		detail_text17: 'Power factor',
		detail_text18: 'Working hours',
		edit_trategy: 'Edit trategy',
		please_select: 'Please select',
		control_mode: 'Control mode',
		msArr: ["Auto", "Manual"],
		lamp_light: 'Lamp light',
		lamp1_light: 'Lamp 1 light',
		lamp2_light: 'Lamp 2 light',
		please_strategy: 'Please select a strategy',
		please_set_light: 'Please set lamp light',
	},
	lampGroup: {
		group_name: 'Group Name',
		group_type: 'Single/Double',
		manage: 'Management',
		desc: 'Group Description',
		control: "Group Control",
		open: 'Open',
		close: 'Close',
		set_light_text: 'Set the brightness of Group',
		doubleType: ['Single lamp group', 'Double lamp group'],
		form_group_name: 'Please enter the group name',
		add_new: 'Add associated lamp',
		bind: 'Bind',
		bind_tip: 'Bind successfully',
		unbind: 'Unbind',
		unbind_tip: 'Unbind successfully',
		association: 'Association lamp',
		select_lamp: 'Select lamp(can search)',
	},
	lampStrategy: {
		time_strategy: 'Time strategy',
		area_strategy: 'Area strategy',
		mode: 'Mode',
		select_mode: 'Select mode',
		strategy_name: 'Strategy name',
		input_strategy_name: 'Input strategy name',
		strategy_type: 'Strategy type',
		strategy_content: 'Strategy Content',
		select_strategy_type: 'Select strategy type',
		system_strategy: 'System strategy',
		offline_strategy: 'Offline strategy',
		modelType: ['unknown', 'System strategy', 'Offline strategy'],
		time_strategy_tip: 'Set the time strategy to control streetlights for scheduled on/off and dimming.',
		area_strategy_tip: 'With regional strategy set, linked streetlights automatically adjust brightness and switch on/off based on sunrise, sunset, and sunlight intensity.',
		time_table: 'Schedule',
		set_lamp2: 'One click setting lamp 2',
		number: 'NO',
		number1: 'NO.1',
		number2: 'NO.2',
		input_lamp_name: 'Enter the lamp name or number',
		lamp_can: 'Optional Lamp',
		lamp_have: 'Selected Lamp',
		offline_must6: 'The maximum strategy time in offline strategy is 6!',
		offline_must2: 'At least 2 strategy times in offline strategy!',
		time_table_must1: 'At least one strategy schedule exists!',
		delect_time_table: 'Are you sure you want to delete this time period?',
		no1_tip: 'The first item is the daily light on time, please set the brightness!',
		no1_tip2: 'The second item is the daily light off time, please set the brightness to 0!',
		time_table_must1: 'At least one strategy schedule exists!',
		please_set_lamp1: 'Please finish setting up lamp 1 first!',
		delete_strategy_tip: 'This operation will permanently delete the strategy. Do you want to continue?',
		sunset_time: 'Sunset time',
		sunrise_time: 'Sunrise time',
		advance: 'In advance',
		set_advance: 'Set in advance',
		delay: 'Delay',
		set_delay: 'Set delay',
		no_set: 'Not set',    
		open_time: 'Open time',
		close_time: 'Close time',
		add_area_strategy: 'Add sunrise and sunset strategy',
		edit_area_strategy: 'Edit sunrise and sunset strategy',
		enter_lng_lat: 'Please enter longitude and latitude',
		enter_lng: 'Please enter longitude',
		enter_lat: 'Please enter latitude',
		to_be_open_time: 'Estimated time to lamp open',
		enter_open_time: 'Please enter the Open time',
		to_be_close_time: 'Estimated time to lamp close' ,
		enter_close_time: 'Please enter the close time',
		lamp_light_set: 'Lamp light set',
		area_strategy_must1: 'Only one area strategy can exist!',
		area_from_tip1: 'Please enter a strategy name!',
		area_from_tip2: 'Please enter the strategy type!',
		area_from_tip3: 'Please enter longitude and latitude!',
		area_from_tip4: 'The Open time cannot be empty!',
		area_from_tip5: 'The Close time cannot be empty',
		area_from_tip6: 'The light of open lamp at sunset should be greater than 0! ',
		is_advance: 'Is advance?',
		operation_type: 'Operation type',
		advance_time: 'Advance time（minute）',
		is_delay: 'Is delay',
		delay_time: 'Delay _time（minute）',
		time_slot: 'Time slot',
		add_time_slot: 'Add time slot',
		please_add_time_slot: 'Please add the time slot',
		do_not_repeat: 'Please do not select a repeating time period',
	},
	sunStrategy: {
		plan_name: 'Plan name',
		input_plan_name: 'Input plan name',
		device_model: 'Device model',
		device_model_id: 'Device model',
		switch_mode: 'Run mode',
		switch_mode_arr: ['Unknown', 'Normal', 'Energy-saving'],
		run_mode: 'Switch mode',
		run_mode_arr: ['Unknown', 'Light-controlled on-off switch', 'Main Power On - Main Power Off', 'Light Control On - Time Control Off', 'Time-Controlled On - Time-Controlled Off'],
		start_time: 'Start time',
		create_by: 'Create date',
		strategy_content: 'Strategy Content',
		select_strategy_type: 'Select strategy type',
		system_strategy: 'System strategy',
		offline_strategy: 'Offline strategy',
		modelType: ['unknown', 'System strategy', 'Offline strategy'],
		time_strategy_tip: 'Set the time strategy to control streetlights for scheduled on/off and dimming.',
		area_strategy_tip: 'With regional strategy set, linked streetlights automatically adjust brightness and switch on/off based on sunrise, sunset, and sunlight intensity.',
		time_table: 'Schedule',
		set_lamp2: 'One click setting lamp 2',
		number: 'NO',
		number1: 'NO.1',
		number2: 'NO.2',
		input_lamp_name: 'Enter the lamp name or number',
		lamp_can: 'Optional Lamp',
		lamp_have: 'Selected Lamp',
		offline_must6: 'The maximum strategy time in offline strategy is 6!',
		offline_must2: 'At least 2 strategy times in offline strategy!',
		time_table_must1: 'At least one strategy schedule exists!',
		delect_time_table: 'Are you sure you want to delete this time period?',
		no1_tip: 'The first item is the daily light on time, please set the brightness!',
		no1_tip2: 'The second item is the daily light off time, please set the brightness to 0!',
		time_table_must1: 'At least one strategy schedule exists!',
		please_set_lamp1: 'Please finish setting up lamp 1 first!',
		delete_strategy_tip: 'This operation will permanently delete the strategy. Do you want to continue?',
		sunset_time: 'Sunset time',
		sunrise_time: 'Sunrise time',
		advance: 'In advance',
		set_advance: 'Set in advance',
		delay: 'Delay',
		set_delay: 'Set delay',
		no_set: 'Not set',    
		open_time: 'Open time',
		close_time: 'Close time',
		add_area_strategy: 'Add sunrise and sunset strategy',
		edit_area_strategy: 'Edit sunrise and sunset strategy',
		enter_lng_lat: 'Please enter longitude and latitude',
		enter_lng: 'Please enter longitude',
		enter_lat: 'Please enter latitude',
		to_be_open_time: 'Estimated time to lamp open',
		enter_open_time: 'Please enter the Open time',
		to_be_close_time: 'Estimated time to lamp close' ,
		enter_close_time: 'Please enter the close time',
		lamp_light_set: 'Lamp light set',
		area_strategy_must1: 'Only one area strategy can exist!',
		area_from_tip1: 'Please enter a strategy name!',
		area_from_tip2: 'Please enter the strategy type!',
		area_from_tip3: 'Please enter longitude and latitude!',
		area_from_tip4: 'The Open time cannot be empty!',
		area_from_tip5: 'The Close time cannot be empty',
		area_from_tip6: 'The light of open lamp at sunset should be greater than 0! ',
		is_advance: 'Is advance?',
		operation_type: 'Operation type',
		advance_time: 'Advance time（minute）',
		is_delay: 'Is delay',
		delay_time: 'Delay _time（minute）',
		time_slot: 'Time slot',
		add_time_slot: 'Add time slot',
		please_add_time_slot: 'Please add the time slot',
		do_not_repeat: 'Please do not select a repeating time period',
	},
	gateway:{
		name: 'Name',
		number: 'Number',
		type: 'Type',
		state: 'State',
		env_sensor: 'Environmental sensors',
		env_sensor_install: 'Is an environmental sensor installed',
		tilt_sensor: 'Tilt Sensor',
		tilt_sensor_install: 'Is a tilt sensor installed',
		is_home: 'Is it displayed on the homepage',
		typeArr: ['','4G gateway','LoRa gateway'],
		envArr: ["Not Installed", "was installed"],
		refresh_3: 'Refresh'
	},
	log: {
		behavior_type: 'Behavior type',
		select_behavior_type:'Select Behavior type',
		number: 'Device number',
		name: 'Behavior name',
		content: 'Behavior content',
		logTypeArr: ['', 'Data reporting', 'Control issuance', 'Control reply', 'Heartbeat reply', 'Alarm data', 'Policy issuance'],
	},
	alarm: {
		warn:'Warn',
		warn_type:'Alarm Type',
		select_warn_type:'Please select the alarm type',
		warn_content:'Alarm Content',
		processing_status:'Processing',
		processed:'Processed',
		success: 'Success',
		arrSte: ["untreated", "Processed"],
		arrType: ["", "Voltage", "Current", "Street Lamp Fault", "Offline"],
	},
	concentrator: {
		loop: 'Loop',
		select_loop: 'Select Loop',
		loop_control: 'Loop control',
		current_ratio: 'Current to speed ratio',
		mail_address: 'Mail address',
		open_connect: 'Open connect',
		close_break: 'Close break',
		expect: 'Expect',
		input_device_name: 'enter the name of the concentrator',
		device_can: 'Optional concentrator',
		device_have: 'Selected concentrator',
		energize_time: 'Select power on time',
		outage_time: 'Select power on time',
		loop_strategy_max6: 'Up to six loop strategies!',
		loop_strategy_min1: 'At least one loop strategy exists!',
		loop_only1_strategy: 'Each circuit can only have one strategy!',
		loop_number: 'Concentrator number',
		enter_loop_number: 'Enter concentrator number!',
		input_number: 'Enter concentrator number!',
		strategy: 'Concentrator strategy',
		loop_strategy: 'Loop strategy',
		plan: 'Plan',
		delete_paln_tip: 'Are you sure you want to delete this plan?',
		please_strategy_name: 'Strategy name cannot be empty',
		please_plan: 'Please fill in the plan!',
		please_name: 'Please fill in the strategy name!',
		fen_arr: ['Unallocated devices', ' Allocated devices'],
		list_arr: ['Remove from list', 'Add to list'],
		back: 'Back',
		allocation_succ: 'Allocation successful',
		unassigned_succ: 'Unassigned successful',
		steType: ["Close", "Open"],
	},
	camera: {
		camera_list: 'Camera list',
		config_edit: 'Config edit',
		delete_camera: 'Delete',
		add_camera: 'Add',
		edit_camera: 'Edit',
		name: 'Camera name',
		enter_name: 'Enter Camera name',
		number: 'Camera Number',
		enter_number: 'Enter Camera Number',
		type: 'Camera Type',
		select_type: 'Select camera Type',
		haikang: 'Hikvision',
		dahua: 'Dahua',
		qiniuyun: 'Qiniu',
		qiniuyun_key: 'Qiniu Cloud KEY',
		enter_qiniuyun_key: 'Enter the Qiniu Cloud KEY',
		qiniuyun_secret: 'Qiniu Cloud SECRET',
		enter_qiniuyun_secret: 'Enter the Qiniu Cloud SECRET',
		select_lamp: 'Select Lamp',
		enter_select_lamp: 'Please select the associated lamp.',
		is_home: 'Home show',
		delete_camera_tip: 'This action will permanently delete the camera. Do you wish to continue?',
		slow: 'Slow',
		fast: 'Fast',
		no_camera: 'No monitoring at the moment',
		please_select_camera: 'Please select the camera first and then perform pan tilt control!'
	},
	broadcast: {
		volume: 'Volume',
		set_volume: 'Set volume',
		enter_volume: 'Enter the Volume',
		volume_start: 'Initial volume',
		task_name: 'Task name',
		enter_task_name: 'Enter Task name',
		device_id: 'Device ID',
		cycles_number: 'Number of cycles',
		enter_cycles_number: 'Enter number of cycles',
		media_list: 'Media list',
		play_music: 'play Music',
		add_task: 'Add broadcast task',
		edit_task: 'Modify broadcast tasks',
		select_device: 'Select Device',
		set_cycles: 'Set the number of cycles',
		music_list: 'Real time broadcast music list',
		plan_name: 'Plan name',
		enter_plan_name: 'Enter the Plan name',
		start_plan_time: 'Start execution time',
		plan_task: 'Tasks Performed',
		select_plan_task: 'Please select the task to be executed',
		select_task_name: 'Task Name/Task ID Executed',
		is_enable: 'Is the plan enabled',
		add_plan: 'Add broadcast plan',
		edit_plan: 'Edit broadcast plan',
		system_file_name: 'System file name',
		select_media: 'Select media files',
		add_media: 'Add media files',
		edit_media: 'Edit media files',
		file_name: 'File name',
		enter_file_name: 'Please enter a file name',
		mp3_file: 'Mp3',
		mp3_file_upload: 'Click on MP3 upload',
		just_mp3: 'Uploading files can only be in MP3 format!',
		mic_id: 'Microphone ID',
		mic_ip: 'Microphone IP',
		terminal_id: 'Device terminal ID',
		mic_state: 'Microphone status',
		link_status: 'Connection status',
		open_mic: 'Turn on the microphone',
		select_broadcast: 'Broadcast number',
		open_mic_successs: 'Microphone successfully turned on',
		close_mic_successs: 'Microphone successfully shut down',
		file_id: 'File id',
		file_name: 'File name',
		add_music: 'Add music',
		edit_music: 'Edit music',
		select_music: 'Select music(search)',
	},
	screen: {
		click_open: 'Open screen',
		click_close: 'Close screen',
		refresh_list: 'Refresh List Data',
		name: 'Screen name',
		number: 'Screen number',
		area_code: 'Area code',
		lamp_name: 'Belong lamp',
		select_lamp_name: 'Select belong lamp',
		brand: 'Brand',
		select_brand: 'Select screen brand',
		state: 'State',
		device_mode: 'Device mode',
		select_device_mode: 'Select device mode',
		add_time: 'Add time',
		update_time: 'Update time',
		brand1: 'YANGBANG',
		brand2: 'XIXUN',
		brand3: 'KALAITE',
		brand4: 'NUOWA',
		screenType: ['YANGBANG','XIXUN','','KALAITE','NUOWA'],
		public_network: 'Public network',
		intranet: 'Intranet',
		patternType: ["Public network", "Intranet"],
		select_screen: 'Select screen',
		add_program:'Add program',
		edit_program:'Edit program',
		screen_allocation: 'Screen allocation',
		put_in: 'Put in',
		program_allocation: 'Program allocation',
		task_name: 'Task name',
		implement_programs: 'Implement programs',
		select_implement_programs: 'Select implement programs',
		task_addition_time: 'Task add time',
		task_state: 'Task state',
		start_and_end_date: 'Start date',
		meidia_name: 'Meidia name',
		meidia_name_tip: 'Please input the eidia name',
		meidia_type: 'Meidia type',
		meidia_url: 'Meidia url',
		click_upload: 'upload',
		video_upload: 'Video upload',
		pic_upload: 'Picture upload',
		edit_text: 'Text editing',
		edit_text_tip: 'Please enter the content. Enter to wrap the line',
		typeArr: ['Text','Picture','Video'],
		just_pic: 'Uploading images can only be in JPG or PNG format!',
		just_mp4: 'Uploading videos can only be in MP4 format!',
		program_name: 'Program name',
		please_program_name: 'Please input the program name',
		screen_fen: ['Unassigned screens',' Assigned screens'],
		versionType: ['Development version', 'embedded version'],
		screen_token: 'Iframe Token(KALAITE)',
		information_account: 'Yangbang account',
		information_password: 'Yangbang password',
		app_key: 'YINSHI key',
		app_secret: 'YINSHI secret',
		imou_key: 'LECHENG key',
		imou_secret: 'LECHENG secret',
		qiniu_key: 'QINIU key',
		qiniu_secret: 'QINIUsecret',
		charging_type: 'Charge version',
		charging_account: 'Charge account',
		charging_password: 'Charge password',
		api_key: 'OneNet key',
		broadcast: 'Broadcast server IP'
	},
	ai:{
		warn_time: 'Warn time',
		warn_camera: 'Warn camera',
		camera_number: 'Camera number',
		camera_remark: 'Camera remark',
		warn_log: 'Warn log',
		warn_view: 'Warn view',
		warn_info: 'Warn info',
		warn_photo: 'Warn photo',
		warn_video: 'Warn video',
		warn_desc: 'Warn desc',
		go: 'Go',
		reception: 'Reception',
		arrSte: ["Unprocessed", "Processed", "Misreported"],
		typeArr: ["Enter", "Leave", "Stop"],
		records: 'Records',
	},
	car: {
		identify_time: 'Identify time',
		original: 'Original',
		view: 'View',
		license_plate: 'License plate',
		car_type: 'License plate type',
		run_direction: 'Run direction',
		use_time: 'Used time',
		less0: 'Less than 0 seconds',
		device_number: 'Device number',
		device_ip: 'Device ip',
		mark: 'Mark',
		normal: 'Normal',
		unmark: 'Unmark',
		mark_data: 'Mark data',
		identify_pic: 'Identify picture',
		viewed: 'Viewed',
		mark_as_viewed: 'Mark as viewed',
		car_pass: 'Vehicle passing through'
	},
	manhole: {
		warn_log: 'Warn log',
		communicatio_id: 'Id',
		describe: 'Describe',
		steArr: ["Normal", "Open", "Loose", "Normal"],
		waterArr: ["Normal", "Water Full", "Medium Water Level", "Low Water Level"],
		overflow: 'overflow',
		sheArr: ["Undefended", "Defensed"],
		undefended: 'Undefended',
		defensed: 'Defensed',
		temp: 'Temp',
		battery: 'Battery',
		water_level: 'Water level',
		presence: 'Presence',
		defense_status: 'Defense status',
		device_status: 'Device status',
		oblique_state: 'Oblique state',
		command_down: 'The command has been issued to the cache, waiting to run on the next device wake-up!',
		logType: ["Normal", "Open", "Loose", "Reset", "Water Overflow", "Equipment Removal", "Abnormal Temperature Sensor", "Abnormal Angle Sensor"],
	},
	manage: {
		company: 'Company',
		please_company: 'Please enter the company',
		company_logo: 'Company logo',
		system_logo: 'System logo',
		keywords: 'Please enter the keywords',
		title: 'System Title',
		province: 'Province',
		city: 'City',
		area: 'Area',
		upload: 'Upload',
		del_tip: 'This operation will permanently delete the company. Do you want to continue?',
		png_tip: 'The company logo can only be a transparent image in png format!',
		pic_tip: 'Can only upload PNG files, and does not exceed 500kb',
		user_account: 'User account',
		password: 'Password',
		phone: 'Phone',
		contact: 'Contact',
		add_user: 'Add user',
		user_id: 'User id',
		basic_config: 'Basic config',
		column_config: 'Column config',
		is_enabled: 'Is it enabled?',
		enabled: 'Enabled',
		disable: 'Disable',
		arrState: ['Disable','Enabled'],
		auth: 'Auth manage',
		column: 'Column',
		set_password: 'Please set a password!',
		project_name: 'Project name',
		project_id: 'Project id',
		project_manager: 'Project manager',
		project_address: 'Project address',
		none: 'None',
		max_access: 'Max access',
		access_status: 'Access status',
		due_Date: 'Due Date',
		access_level: 'Access level',
		address: 'address',
		access_status_arr: ['Trial', 'Application', 'Normal'],
		tiday: 'tiday',
		after_month1: 'After 1 month',
		after_month3: 'After 3 month',
		after_month6: 'After 6 month',
		after_year1: 'After 1 year',
		after_year2: 'After 2 year',
		forever: 'forever',
		lnglat_none: 'The longitude and latitude of the device are not marked!',
		operation_date: 'Operation date',
		login_ip: 'Login ip',
		operation_content: 'Operation content',
		login_date: 'Login_date',
	},
	other: {
		goSystem: 'Entering the system',
	}
};
